"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = exports.isEmailValidExtended = exports.isUUIDV4Valid = exports.isEmailValid = void 0;
var tslib_1 = require("tslib");
var emailValidator = tslib_1.__importStar(require("email-validator"));
var isEmailValid = function (str) {
    return emailValidator.validate(str);
};
exports.isEmailValid = isEmailValid;
var VALIDATE_UUID_REGEX = /(^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$)/;
var isUUIDV4Valid = function (text) {
    var pattern = VALIDATE_UUID_REGEX;
    return pattern.test(text);
};
exports.isUUIDV4Valid = isUUIDV4Valid;
var isEmailValidExtended = function (str) {
    var tester = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    if (!str) {
        return false;
    }
    if (str.length > 254) {
        return false;
    }
    var valid = tester.test(str);
    if (!valid) {
        return false;
    }
    var parts = str.split('@');
    if (parts[0].length > 64) {
        return false;
    }
    var domainParts = parts[1].split('.');
    if (domainParts.some(function (part) { return part.length > 63; })) {
        return false;
    }
    return true;
};
exports.isEmailValidExtended = isEmailValidExtended;
var isUrl = function (text) {
    var pattern = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
    return pattern.test(text);
};
exports.isUrl = isUrl;
//# sourceMappingURL=index.js.map